import { ServiceData } from '@/types';

import articles from './YOGA_ARTICLES_EE.json';
import exercises from './YOGA_EXERCISES_EE.json';
import recipes from './YOGA_RECIPES_EE.json';

export const YOGA_DATA_EE: ServiceData = {
  articles,
  exercises,
  recipes,
};
